import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '@utils/format';
import { OrderDetailManagementTable } from '@components/templates/myAccount/manageOrderDetail/OrderDetailManagementTable';
import { Modules, useModule } from '@hooks/useModule';
import { RatingForm } from '../RatingForm';

export interface OrderProductsTableProps {
    products: {
        uuid: string;
        name: string;
        attributes: string[];
        quantity: number;
        price: number;
        rating?: number;
    }[];
    withRatings?: boolean;
}

export const OrderProductsTable: FC<OrderProductsTableProps> = ({ products, withRatings }) => {
    const { isModuleActive } = useModule();
    const { t } = useTranslation();

    const translations = {
        name: t('products-table-component.header.name'),
        attributes: t('products-table-component.header.attributes'),
        quantity: t('products-table-component.header.quantity'),
        price: t('products-table-component.header.price'),
        rating: t('products-table-component.header.ratings'),
    };

    const headerItems = [
        { text: translations.name },
        { text: translations.attributes },
        { classes: 'text-start text-md-center', text: translations.quantity },
        { classes: 'text-end', hideOnMobile: true, text: translations.price },
        ...(isModuleActive(Modules.rating) && withRatings
            ? [{ classes: 'text-end', hideOnMobile: true, text: translations.rating }]
            : []),
    ];

    return (
        <OrderDetailManagementTable
            withActions={false}
            header={headerItems}
            content={products.map((product) => {
                return {
                    cells: [
                        { content: product.name },
                        { content: product.attributes?.join(', ') || '' },
                        { classes: 'text-start text-md-center', content: `${product.quantity}` },
                        { classes: 'text-end', content: formatPrice(product.price) },
                        ...(isModuleActive(Modules.rating) && withRatings
                            ? [
                                  {
                                      classes: 'text-end',
                                      content: <RatingForm productUuid={product.uuid} startValue={product.rating} />,
                                  },
                              ]
                            : []),
                    ],
                    options: [],
                };
            })}
        />
    );
};
